import { IconButton } from '@mui/material';
import React from 'react';

const ButtonGroupIconButton = (props: any) => {
  const { disableElevation, fullWidth, variant, ...iconButtonProps } = props;
  return <IconButton {...iconButtonProps} />;
};

export default ButtonGroupIconButton;
